import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ExclusiveSection() {
  const featured = articles[0];
  const sideArticles = articles.slice(1, 3);

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="lg:w-1/2">
              <Link to={`/article/${featured.slug}`} className="block group cursor-pointer">
                <div className="relative rounded-lg overflow-hidden aspect-[4/3]">
                  <img
                    src={featured.image}
                    alt={featured.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute top-4 left-4 flex gap-2">
                    <span className="px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-label whitespace-nowrap">
                      独家
                    </span>
                    <span className="px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-label whitespace-nowrap">
                      实锤
                    </span>
                    <span className="px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-label whitespace-nowrap">
                      高清原图
                    </span>
                  </div>
                </div>
              </Link>
            </div>

            <div className="lg:w-1/2 flex flex-col gap-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 leading-tight mb-4">
                  {featured.title}
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {featured.excerpt}
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {featured.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 rounded-full border border-foreground-200 text-xs text-foreground-600 whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <Link
                  to={`/article/${featured.slug}`}
                  className="inline-flex items-center gap-1 text-sm text-primary-500 font-label font-semibold hover:text-primary-600 transition-colors cursor-pointer"
                >
                  阅读全文 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              <div className="bg-foreground-950 rounded-lg p-5">
                <div className="flex items-center gap-3 mb-4">
                  <span className="px-2.5 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-label whitespace-nowrap">
                    更多猛料
                  </span>
                </div>
                {sideArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="flex items-center gap-4 py-3 border-b border-background-50/10 last:border-0 group cursor-pointer"
                  >
                    <div className="flex-1">
                      <h4 className="text-sm text-background-50 font-heading font-bold group-hover:text-primary-400 transition-colors line-clamp-1">
                        {article.title}
                      </h4>
                      <p className="text-xs text-background-50/50 mt-1 line-clamp-2">{article.excerpt}</p>
                    </div>
                    <div className="w-16 h-16 rounded-md overflow-hidden flex-shrink-0">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}